import {Navigate,useParams} from "react-router-dom";
export default function LegacyAdminRedirect() {
  const params = useParams();
  const rest = params["*"];
  return <Navigate to={rest ? `/yonetici/${rest}` : "/yonetici"} replace />;
}
